import React, { Component } from 'react';
import classes from './Login.module.css';
import logo from '../../assets/logo.png';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import axios2 from '../../axios';

class Login extends Component {
    state = {
        loginForm: {
            email: {
                value: '',
                valid: false
            },
            password: {
                value: '',
                valid: false
            }
        },
        isPasswordEntered: false,
        isFormValid: false,
        isErrorMessageVisible: false,
        errorMessage: 'Please fill all the details'
    }
   
    passwordRef = React.createRef();

    inputOnChangeHandler = (event, key) => {
        const form = {
            ...this.state.loginForm
           };
    
           const inputField = {...form[key]};
           inputField.value = event.target.value;
           if(inputField.value.trim() !== '') inputField.valid = true;
           else inputField.valid = false;
           form[key] = inputField;
    
           let isFormValid = true;
           for (let inputIdent in form) {
             if(!form[inputIdent].valid) isFormValid = false;
            }

           this.setState({
                 loginForm: form,
                 isFormValid: isFormValid,
                 isErrorMessageVisible: false
            });
        if(key === 'password') this.passwordOnTypeHandler(event);
    }

    passwordOnTypeHandler = (event) => {
        if(event.target.value.length !== 0){
            this.setState({isPasswordEntered: true});
        } else {
            this.setState({isPasswordEntered: false});
        }
    }

    onShowHideHandler = (event) => {
        if(event.target.innerText === 'Show') {
            event.target.innerText = 'Hide';
            this.passwordRef.current.type = 'text';
        } else {
            event.target.innerText = 'Show';
            this.passwordRef.current.type = 'password';

        }
    }
    onEnterHandler = (event) => {
        if(event.key === 'Enter') this.onLogin();
    }

    onLogin = () => {
       if(!this.state.isFormValid) {
        this.setState({isErrorMessageVisible : true, errorMessage: 'Please fill all the details' });
        return;
       } else {
        this.setState({isErrorMessageVisible : false});
       }

       const user = {
           email: this.state.loginForm.email.value,
           password: this.state.loginForm.password.value,
           returnSecureToken: true
       }
       axios2.post(':signInWithPassword?key=AIzaSyCz-SR_b_8Rn41e9xr1i7iQcwJaCR9DFJ0', user)
        .then(response => {
            this.props.setLoginStatus(true, response.data.localId, response.data.idToken, new Date().getTime() + (response.data.expiresIn * 1000));
                localStorage.setItem('tokenData', JSON.stringify({
                    localId: 'fkiG' + response.data.localId,
                    idToken: response.data.idToken,
                    expire: new Date().getTime() + (response.data.expiresIn * 1000)
                }));
            axios.get('/users/'+ response.data.localId +'.json?auth='+ response.data.idToken)
            .then(response2 => {
                this.props.setUserData(response2.data);
            })
        })
        .catch(err=>{
            switch (err.response.data.error.message) {
                case 'INVALID_EMAIL':
                    this.setState({errorMessage : 'Invalid Email'});
                    break;
                case 'EMAIL_NOT_FOUND':
                    this.setState({errorMessage : 'Email doesn\'t exist'});
                    break;
                case 'INVALID_PASSWORD':
                    this.setState({errorMessage : 'Incorrect Password'});
                    break;
                case 'USER_DISABLED':
                    this.setState({errorMessage : 'Your account is Suspended'});
                    break;
            }
            this.setState({isErrorMessageVisible : true});
        })
        
    }

    render(){
    return(
    <div className={classes.loginModule}>
       <div className={classes.login}>
           <div>
               <img src={logo} width="200" height="60" alt="fakeinsta" />
           </div>
           <div>
             <form>
                <div>
                    <label htmlFor="email" className={classes.formLabel}>Email</label><br/>
                    <input type="email" id="email" value={this.state.loginForm.email.value} 
                    className={classes.formInputs} maxLength="30"
                    onChange={(event)=>this.inputOnChangeHandler(event, 'email')}
                    onKeyPress={(event)=> this.onEnterHandler(event)}/>
                </div>
                <div>
                    <label htmlFor="pwd" className={classes.formLabel}>Password</label><br/>
                    <input type="password" id="pwd" className={classes.formInputs} maxLength="20" 
                     value={this.state.loginForm.password.value} 
                     onChange={(event)=>this.inputOnChangeHandler(event, 'password')}
                     ref={this.passwordRef}  onKeyPress={(event)=> this.onEnterHandler(event)}/>
                     {this.state.isPasswordEntered ?
                        <span className={classes.showHide}>
                            <button type="button" onClick={(event)=>this.onShowHideHandler(event)}>Show</button>
                        </span> : null}
                </div>
                <div>
                    <button type="button" className={classes.loginBtn} onClick={this.onLogin}>Log In</button>
                   {this.state.isErrorMessageVisible ?
                    <div>
                        <p className={classes.error}>
                            <FontAwesomeIcon icon={faExclamationCircle}/>&nbsp;
                            {this.state.errorMessage}
                        </p>
                    </div> : null 
                    }   
                </div>
             </form>
           </div>
       </div>
       <div className={classes.signup}>
         <p>
           Don't have an account? &nbsp;
           <Link to="/signup" style={{color: '#efff00',fontWeight: 500,textDecoration: 'none'}}>
               Sign Up
            </Link>
         </p>        
       </div>
    </div>
    )
    }
}


const mapDispatchToProps = dispatch => {
    return {
        setLoginStatus: (isLoggedIn, userId, authToken, expiresIn) => 
                        dispatch({
                            type: 'SET_LOGIN_STATUS',
                            isLoggedIn: isLoggedIn,
                            localId: userId,
                            idToken: authToken,
                            expiresIn: expiresIn
                        }),
        setUserData: (value) => dispatch({type: 'SET_USER_DATA', value:value})
    }
}
export default connect(null, mapDispatchToProps)(Login);